import InfoTooltip from './InfoTooltip';
import { cn } from '../utils/utils';

interface Props {
    text: string;
    help: string;
    /** Extra classes for the label row — e.g. `mb-0` when the surrounding
     *  field already provides the spacing between label and input. */
    className?: string;
}

// A form-field label with an inline info tooltip explaining what to fill in.
// Shared across the "Vouchers & banners" forms and the `labelAbove` variants of
// InputField / SelectField so the (i) help styling stays consistent. Grayscale
// per the design system; tenant primary is untouched.
const LabelWithHelp = ({ text, help, className }: Props) => (
    <div className={cn('mb-1 flex items-center gap-1.5', className)}>
        <span className={'text-sm font-medium text-foreground/70'}>{text}</span>
        <InfoTooltip text={help} />
    </div>
);

export default LabelWithHelp;
